var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-banner-container',{attrs:{"header":"Nutrition"}},[_c('calendar-dots',{attrs:{"accent-color":"nutrition"}}),_c('today-nutrition-section',{staticClass:"mx-4 mt-n6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }